import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d636a724")

_pushScopeId("data-v-d636a724")
const _hoisted_1 = {
  key: 0,
  class: "select-wallet"
}
const _hoisted_2 = {
  key: 1,
  class: "wallet-info"
}
const _hoisted_3 = { style: {"position":"relative"} }
const _hoisted_4 = { class: "input" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "Stake", -1)
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { style: {"padding-left":"11px","font-size":"16px"} }, "SOL", -1)
const _hoisted_10 = { class: "stakeInfo" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "You will receive", -1)
const _hoisted_13 = { class: "item" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "APR", -1)
const _hoisted_15 = { class: "item" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, "Rate", -1)
const _hoisted_17 = {
  key: 0,
  class: "select-wallet"
}
const _hoisted_18 = {
  key: 1,
  class: "wallet-info-app"
}
const _hoisted_19 = { style: {"position":"relative"} }
const _hoisted_20 = { class: "inputApp" }
const _hoisted_21 = { class: "title" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", null, "Stake", -1)
const _hoisted_23 = { class: "content" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { style: {"padding-left":"5px"} }, "SOL", -1)
const _hoisted_25 = { class: "stakeInfoApp" }
const _hoisted_26 = { class: "item" }
const _hoisted_27 = /*#__PURE__*/_createVNode("span", null, "You will receive", -1)
const _hoisted_28 = { class: "item" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", null, "APR", -1)
const _hoisted_30 = { class: "item" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", null, "Rate", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_q_space = _resolveComponent("q-space")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_card_section = _resolveComponent("q-card-section")
  const _component_q_input = _resolveComponent("q-input")
  const _component_q_card = _resolveComponent("q-card")
  const _component_q_dialog = _resolveComponent("q-dialog")
  const _directive_close_popup = _resolveDirective("close-popup")

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.stakeSOLDialogVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.stakeSOLDialogVisible = $event))
  }, {
    default: _withId(() => [
      _createVNode(_component_q_card, { class: "reward gt-sm" }, {
        default: _withId(() => [
          _createVNode(_component_q_card_section, { class: "row items-center rewardTitle" }, {
            default: _withId(() => [
              _createVNode("div", null, _toDisplayString(_ctx.dialogTitle), 1),
              _createVNode(_component_q_space),
              _withDirectives(_createVNode(_component_q_btn, {
                icon: "close",
                flat: "",
                round: ""
              }, null, 512), [
                [_directive_close_popup]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "rewardBody" }, {
            default: _withId(() => [
              (!_ctx.walletAddress)
                ? (_openBlock(), _createBlock("div", _hoisted_1, [
                    _createVNode("div", null, _toDisplayString(_ctx.t('wallet.connectToAWallet')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.walletAddress&&!_ctx.isLoadingUserDetails)
                ? (_openBlock(), _createBlock("div", _hoisted_2, [
                    _createVNode("div", _hoisted_3, [
                      _createVNode("div", _hoisted_4, [
                        _createVNode("div", _hoisted_5, [
                          _hoisted_6,
                          _createVNode("span", null, "Balance: " + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userSOLBalance,4)) + " SOL", 1)
                        ]),
                        _createVNode("div", _hoisted_7, [
                          _createVNode("div", _hoisted_8, [
                            _createVNode("img", {
                              src: _ctx.solImg,
                              height: "42",
                              width: "42"
                            }, null, 8, ["src"]),
                            _hoisted_9
                          ]),
                          _createVNode(_component_q_input, {
                            style: {"width":"80%","font-size":"20px"},
                            color: "#ffffff",
                            borderless: "",
                            "input-style": { color: '#ffffff',textAlign:'right' },
                            "model-value": _ctx.stakeAmount,
                            "onUpdate:modelValue": _ctx.stakeAmountInput
                          }, null, 8, ["model-value", "onUpdate:modelValue"])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode("span", null, "~" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.receiveAmount,4)) + " " + _toDisplayString(_ctx.receiveSymbol), 1)
                      ]),
                      _createVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode("span", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.stakeApy,3)) + "%", 1)
                      ]),
                      _createVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode("span", null, "1 " + _toDisplayString(_ctx.receiveSymbol) + " = ~ " + _toDisplayString(_ctx.formatBigNumberStr(_ctx.stakeExchangeRate,4)) + " SOL", 1)
                      ])
                    ]),
                    _createVNode(_component_q_btn, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.stakeAction())),
                      style: _ctx.stakeButtonEnable?'background: #2FCEFB;':' background: #2B3866;',
                      disable: !_ctx.stakeButtonEnable,
                      class: "btn",
                      "no-caps": ""
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.stakeButtonText), 1)
                      ]),
                      _: 1
                    }, 8, ["style", "disable"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_card, { class: "rewardApp lt-md" }, {
        default: _withId(() => [
          _createVNode(_component_q_card_section, { class: "row items-center rewardTitleApp" }, {
            default: _withId(() => [
              _createVNode("div", null, _toDisplayString(_ctx.dialogTitle), 1),
              _createVNode(_component_q_space),
              _withDirectives(_createVNode(_component_q_btn, {
                icon: "close",
                flat: "",
                round: ""
              }, null, 512), [
                [_directive_close_popup]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "rewardBodyApp" }, {
            default: _withId(() => [
              (!_ctx.walletAddress)
                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                    _createVNode("div", null, _toDisplayString(_ctx.t('wallet.connectToAWallet')), 1)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_18, [
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, [
                        _createVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createVNode("span", null, "Balance: " + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userSOLBalance,4)) + " SOL", 1)
                        ]),
                        _createVNode("div", _hoisted_23, [
                          _createVNode("div", null, [
                            _createVNode("img", {
                              src: _ctx.solImg,
                              height: "22",
                              width: "22"
                            }, null, 8, ["src"]),
                            _hoisted_24
                          ]),
                          _createVNode(_component_q_input, {
                            style: {"width":"80%","font-size":"14px"},
                            color: "#ffffff",
                            borderless: "",
                            "input-style": { color: '#ffffff',textAlign:'right' },
                            "model-value": _ctx.stakeAmount,
                            "onUpdate:modelValue": _ctx.stakeAmountInput
                          }, null, 8, ["model-value", "onUpdate:modelValue"])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_25, [
                      _createVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createVNode("span", null, "~" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.receiveAmount,4)) + " " + _toDisplayString(_ctx.receiveSymbol), 1)
                      ]),
                      _createVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createVNode("span", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.stakeApy,3)) + "%", 1)
                      ]),
                      _createVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createVNode("span", null, "1 " + _toDisplayString(_ctx.receiveSymbol) + " = ~ " + _toDisplayString(_ctx.formatBigNumberStr(_ctx.stakeExchangeRate,4)) + " SOL", 1)
                      ])
                    ]),
                    _createVNode(_component_q_btn, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.stakeAction())),
                      style: _ctx.stakeButtonEnable?'background: #2FCEFB;':' background: #2B3866;',
                      disable: !_ctx.stakeButtonEnable,
                      class: "button-app",
                      "no-caps": ""
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.stakeButtonText), 1)
                      ]),
                      _: 1
                    }, 8, ["style", "disable"])
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
})